<template>
  <ul class="date-range-presets">
    <li v-for="preset in presets" :key="preset.key" :class="{ 'is-divider': preset.key === 'custom' }">
      <button
        type="button"
        :class="['preset-btn', { active: selected === preset.key, custom: preset.key === 'custom' }]"
        :aria-pressed="selected === preset.key ? 'true' : 'false'"
        @click="$emit('select', preset.key)"
      >
        <span v-if="preset.key === 'custom'" class="custom-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M3 9h18M8 3v4M16 3v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="preset-label">{{ preset.label }}</span>
      </button>
    </li>
  </ul>
</template>

<script setup>
import { PRESETS as presets } from '@/Modules/utils/dateRange.js'

defineProps({
  selected: {
    type: String,
    default: null
  }
})

defineEmits(['select'])
</script>

<style scoped>
.date-range-presets {
  list-style: none;
  margin: 0;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 180px;
  border-right: 1px solid var(--color-border);
  background: var(--color-background-soft);
}

.is-divider {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid var(--color-border);
}

.preset-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-left: 2px solid transparent;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text);
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.preset-btn:hover {
  background: var(--highlights-hover);
  color: var(--highlights);
}

.preset-btn.active {
  background: var(--highlights-background);
  color: var(--highlights);
  border-left-color: var(--highlights);
  font-weight: 600;
}

.preset-btn.custom {
  color: var(--color-text);
  opacity: 0.85;
}

.preset-btn.custom:hover {
  opacity: 1;
}

.custom-icon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.preset-label {
  flex: 1;
}
</style>
